import React from "react";
import { motion } from "framer-motion";
import { ArrowDownIcon } from "lucide-react";
import { CourtLines } from "../brand/CourtLines";
import { BoxMockup } from "../mockup/BoxMockup";
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section id="top" aria-labelledby="hero-title" className="relative overflow-hidden bg-navy" data-id="element-122" data-mp="cy7d9874m0dd">
      <CourtLines className="pointer-events-none absolute -right-48 -top-32 h-[480px] w-[480px] text-cyan/[0.08] lg:-right-40 lg:-top-40 lg:h-[820px] lg:w-[820px]" data-id="element-123" data-mp="hsl36v30rfan" />

      <div className="container-x relative flex flex-col items-center gap-6 pb-12 pt-7 text-center sm:gap-8 sm:pb-16 sm:pt-12 lg:grid lg:grid-cols-2 lg:items-center lg:gap-12 lg:pb-24 lg:pt-20 lg:text-left" data-id="element-124" data-mp="qu2piv70sd7s">
        <div className="lg:order-1" data-id="element-125" data-mp="10knlsbz815nj">
          <motion.h1 id="hero-title" initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease
        }} className="font-display text-[clamp(2.5rem,12vw,5.6rem)] font-extrabold uppercase leading-[0.9] text-ice lg:text-[clamp(3.4rem,6vw,5.8rem)]" data-id="element-126" data-mp="15ks3u6fs28fv">
            12 floor hockey lessons.
            <span className="block text-cyan" data-id="element-127" data-mp="3vv0zukrxly60">Ready to teach.</span>
          </motion.h1>

          <a href="#offer" className="btn-primary mt-9 hidden lg:inline-flex" data-id="element-128" data-mp="3vwu824i70qg4">
            Explore the $27 bundle
            <ArrowDownIcon className="h-5 w-5" aria-hidden="true" data-id="element-129" data-mp="seamtlxxmkut" />
          </a>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease,
        delay: 0.1
      }} className="w-full lg:order-2" data-id="element-130" data-mp="nf7hs1hycemu">
          <BoxMockup data-id="element-131" data-mp="en5oqoa7q0ml" />
        </motion.div>

        <a href="#offer" className="btn-primary w-full max-w-[420px] justify-center lg:hidden" data-id="element-132" data-mp="eme0xzmux76v">
          Explore the $27 bundle
          <ArrowDownIcon className="h-5 w-5" aria-hidden="true" data-id="element-133" data-mp="1b6mrifc25y84" />
        </a>
      </div>
    </section>;
}